var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStoryTelling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.351,
    height: 122.673,
    viewBox: "0 0 100.351 122.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-book-65304",
    transform: "translate(-27.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_251",
    "data-name": "Caminho 251",
    d: "M306.211,121.755H291.6V109.235a9.773,9.773,0,0,0-13.185-9.185l-59.16,21.876c-.021.009-.036.025-.058.034a2.548,2.548,0,0,0-.324.191,2.729,2.729,0,0,0-.534.361,2.649,2.649,0,0,0-.245.3,2.766,2.766,0,0,0-.346.513,2.709,2.709,0,0,0-.137.376,2.756,2.756,0,0,0-.126.621c-.006.074-.043.136-.043.211v94.8a2.775,2.775,0,0,0,2.777,2.777h85.989A11.6,11.6,0,0,0,317.8,210.526V133.341a11.6,11.6,0,0,0-11.588-11.584Zm-25.871-16.5a4.224,4.224,0,0,1,5.708,3.978v12.519H235.733Zm31.9,105.264a6.039,6.039,0,0,1-6.033,6.031H222.994V127.3h83.215a6.039,6.039,0,0,1,6.033,6.033v77.185Z",
    transform: "translate(-189.663 -99.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252",
    "data-name": "Caminho 252",
    d: "M330.65,248.494a24.341,24.341,0,0,1-10.409,2.313,24.591,24.591,0,0,1-24.564-24.564,24.315,24.315,0,0,1,2.315-10.409,2.776,2.776,0,0,0-3.691-3.691,30.115,30.115,0,1,0,40.039,40.042,2.776,2.776,0,0,0-3.691-3.691Zm-23.587,15.488a24.552,24.552,0,0,1-16.532-42.714,30.156,30.156,0,0,0,34.685,34.684,24.675,24.675,0,0,1-18.153,8.03Z",
    transform: "translate(-226.644 -169.317)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryTelling);
export default __webpack_public_path__ + "static/media/story-telling.2f7e8d69153dd0291c17ccc67c3a9727.svg";
export { ForwardRef as ReactComponent };